const faqItems = [
  {
    q: '四虎影视大全需要付费才能观看吗？',
    a: '完全不需要！四虎影视大全承诺永久免费在线观看，所有影视资源均面向全网用户开放，无需注册账号、无需充值会员、无需任何付费即可畅享高清画质。我们通过广告合作维持平台运营，确保每一位用户都能零门槛享受流畅观影体验。',
  },
  {
    q: '为什么四虎影视大全播放不卡顿、不缓冲？',
    a: '四虎影视大全采用智能多线CDN加速技术，在全国部署了数百个加速节点，系统会根据您的网络环境自动匹配最优线路。同时我们支持H.265高效编码格式，在保证高清画质的前提下大幅降低带宽消耗，即使在移动网络环境下也能实现秒开流畅播放。',
  },
  {
    q: '影视资源每天更新吗？最新剧集多久能看？',
    a: '是的，四虎影视大全的片源团队每天24小时不间断更新，热门电视剧、综艺节目在播出后2小时内即可上线，电影资源同步院线窗口期第一时间更新。日韩剧场、欧美大片、国产热剧同步跟进，确保您不会错过任何精彩内容，关注我们的最新动态模块可随时了解更新情况。',
  },
  {
    q: '支持手机和电脑观看吗？画质可以选择吗？',
    a: '四虎影视大全全面适配手机、平板、电脑等全终端设备，无需下载任何播放器或APP。同时我们提供标清、高清、超清多档画质自由切换，系统会智能推荐最适合您设备和网络条件的画质档位，让您随时随地享受最佳观影效果。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/10 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-question-answer-line text-xs"></i>
            常见问题
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">关于四虎影视大全，您可能想了解的</p>
        </div>

        <div className="grid gap-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-200/70 rounded-xl border border-background-300/40 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4 text-foreground-500 text-sm leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}